export const ADMIN_ROLES = ['administrator', 'executive_director', 'medical_director']

export const EMPTY_LABEL = 'N/A'